import { render } from "./ArchiveMail.vue?vue&type=template&id=5ec70955&scoped=true"
import script from "./ArchiveMail.vue?vue&type=script&lang=js"
export * from "./ArchiveMail.vue?vue&type=script&lang=js"

import "./ArchiveMail.vue?vue&type=style&index=0&id=5ec70955&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec70955"]])

export default __exports__